import React from 'react';
const UnChecked = (props) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 3h18v18H3V3zm16 16V5H5v14h14z" fill="#ffffff" />
  </svg>
);
export default UnChecked;
